module.exports = __webpack_public_path__ + "img/datos_clinicas.2f3adfae.svg";